export var EditPage;
(function (EditPage) {
    EditPage[EditPage["EventBaseData"] = 0] = "EventBaseData";
    EditPage[EditPage["EventDetailedData"] = 1] = "EventDetailedData";
    EditPage[EditPage["Competitions"] = 10] = "Competitions";
    EditPage[EditPage["Officials"] = 20] = "Officials";
    EditPage[EditPage["TechnicalInfo"] = 30] = "TechnicalInfo";
})(EditPage || (EditPage = {}));
